
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlists/[id]/[slug]",
      function () {
        return require("private-next-pages/playlists/[id]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playlists/[id]/[slug]"])
      });
    }
  